import {connection} from "./connection";
import {cubeModel} from "./cube";
import {occupancyModel} from "./occupancy";
import {OccupancyResponse} from "./types";

export async function openAndRelease(occupancy: OccupancyResponse) {
	await connection.open(occupancy.id);
	await cubeModel.remove(occupancy.box.cube.hostname);
	return await occupancyModel.release(occupancy);
}

export async function openAndKeep(occupancy: OccupancyResponse) {
	return await connection.open(occupancy.id);
}
